import { DISCORD_BRAND_COLOR, DISCORD_INVITE_URL } from '@consts';
import DiscordIcon from '@icons/DiscordIcon';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import { Trans } from 'react-i18next';
import { useLandingPageTranslation } from './useLandingPageTranslation';

export default function GoalLandingPageDiscordBanner() {
  const { t } = useLandingPageTranslation();

  return (
    <div className='w-full py-md' style={{ backgroundColor: DISCORD_BRAND_COLOR }}>
      <div
        className={classNames(
          'w-full max-w-[1200px] mx-auto px-sm flex justify-between',
          // RESPONSIVE STYLES
          'flex-col items-center gap-md @[640px]:flex-row @[640px]:items-center @[640px]:gap-lg'
        )}
      >
        <div className='flex flex-row items-center gap-md'>
          <DiscordIcon size={36} className={classNames('shrink-0', setupForDark('text-white'))} />
          {/* RESPONSIVE STYLES */}
          <p
            className={classNames(
              'P3R @[640px]:P2R  @[640px]:text-left',
              setupForDark('text-white')
            )}
          >
            <Trans
              i18nKey='domains.goals.landingPage.discordBanner.text'
              components={{ strong: <strong className='P3B @[640px]:P2B' /> }}
            />
          </p>
        </div>
        <a
          href={DISCORD_INVITE_URL}
          target='_blank'
          rel='noopener noreferrer'
          className={classNames(
            // RESPONSIVE STYLES
            'shrink-0 rounded-full px-lg py-sm L3M @[640px]:L2M whitespace-nowrap no-underline hover:scale-105 transition-transform',
            setupForDark('bg-white')
          )}
          style={{ color: DISCORD_BRAND_COLOR }}
        >
          {t('domains.goals.landingPage.discordBanner.cta')}
        </a>
      </div>
    </div>
  );
}
